import { ShipmentType } from 'features/ShipmentDetails'
import { containerTypeGroupTerms } from 'features/TransportUnits'
import { truncate } from 'lodash-es'
import { LocalisationStore } from 'utils/localisation'

export const CONTAINER_TYPE_22GP = '22GP'
export const CONTAINER_TYPE_42GP = '42GP'
export const CONTAINER_TYPE_45GP = '45GP'
export type FCLCargoContainerType = '22GP' | '42GP' | '45GP'

type BaseCargo = {
  type: ShipmentType
  quantity: number
  commodityType?: string
  commodityID?: string
}

export type FCLCargoJSON = BaseCargo & {
  type: 'fcl'
  containerType: FCLCargoContainerType
  grossWeight?: number
}

export type LCLCargoJSON = BaseCargo & {
  type: 'lcl'
  width: number
  height: number
  length: number
  volume: number
  grossWeight?: number
}

export type Cargo = FCLCargoJSON | LCLCargoJSON

const fclCargoString = (cargo: FCLCargoJSON, loc: LocalisationStore) => {
  return loc.translate('cargo-fcl', {
    count: cargo.quantity,
    type: loc.translate(containerTypeGroupTerms[cargo.containerType]),
  })
}

const lclCargoString = (cargo: LCLCargoJSON, loc: LocalisationStore) => {
  const volume = Number(cargo.volume).toFixed(2)
  const weight = cargo.grossWeight
  return loc.translate('cargo-lcl', {
    count: cargo.quantity,
    commodity:
      cargo.commodityType && cargo.commodityType !== 'N/A'
        ? truncate(cargo.commodityType, { length: 50, separator: /,? +/ })
        : ' ', // prevent i18next::interpolator: missed to pass in variable
    volume,
    weight,
  })
}

export const cargoString = (cargo: Cargo, loc: LocalisationStore) => {
  return cargo.type === 'fcl' ? fclCargoString(cargo, loc) : lclCargoString(cargo, loc)
}
